import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';

export default function getPlatformInfo(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('platformInfo')) {
        return;
    }

    return function(...requestedPlatformInfo: string[]): Promise<IDict<any>> {
        return messageBus
            .sendRequest<IDict<any>>(
                'platformInfo',
                Maybe.just(JSON.stringify(requestedPlatformInfo))
            )
            .then(response => {
                return response.value;
            });
    };
}
